<template>
    <div class="returnExtensionAgent">
        <el-dialog title="清退推广员" :visible.sync="dialogVisible" width="600px">
            <p class="returnTips">若清退该推广员，该用户将不再是推广员，下级客户会全部解绑。 确定要清退么？</p>
            <p class="tips">*该用户可根据规则，再次成为推广员</p>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click.native="affirm">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import {auditPassRejectReturn} from '@/api/extensionAgent'
import {mapGetters, mapActions} from 'vuex'
export default {
    name: 'returnExtensionAgent',
    data() {
        return {
            dialogVisible: false,
            params: {
                innerid: '',
                status: '100'
            }
        }
    },
    methods: {
        affirm() {
            this.setLoading(true)
            auditPassRejectReturn({
                data: Object.assign({}, this.params),
                success: data => {
                    this.setLoading(false)
                    this.$message.success('清退成功')
                    this.dialogVisible = false
                    this.$emit('getList')
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions([
            'setLoading'
        ])
    }
}
</script>
<style lang="scss">
    .returnExtensionAgent{
        .el-dialog{
            .returnTips{
                color: #F56C6C;
                text-align: center;
            }
            .tips{
                text-align: center;
                color: #909399;
                margin-top: 20px;
            }
        }
    }
</style>